import { QueryClient, QueryClientProvider } from "react-query";
import Routes from "./routes.js";
import "./App.css";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Client_App_ID } from "./utils/config.js";
import { ColorProvider } from "./components/ContextApi.js";
import { GradientProvider } from "./components/GradientContext .js";
import { MyProvider } from "./components/ContextObject.js";
import { EditWheelProvider } from "./components/EditWheelProvider.js";
import { Provider } from "react-redux";
import { store } from "./redux/index.js";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { resetContainerProps } from "./redux/reducers/PrevStylesCopy/Container.js";
import { useEffect } from "react";
import CreateFolderDialog from "./components/WheelGallery/WheelListing/Folders/Components/CreateFolder.jsx";
import { WheelSegmentsProvider } from "./contexts/wheelSegments.jsx";
import { ThemeProvider } from "@mui/material/styles";
import { Muitheme } from "./utils/theme.js";
import DialogPopup from "./components/DialogPopup/index.jsx";
import UpgradePopup from "./components/Referrals/children/UpgradePopup.jsx";
import { BrowserRouter } from "react-router-dom";
import NotificationHandler from "./utils/NotificationHandler";

const queryClient = new QueryClient({});

const App = () => {
  useEffect(() => {
    // Reset container properties when the app is loaded or refreshed
    store.dispatch(resetContainerProps());
  }, []);

  return (
    <BrowserRouter>
      <Provider store={store}>
        <ThemeProvider theme={Muitheme}>
          <DndProvider backend={HTML5Backend}>
            <MyProvider>
              <WheelSegmentsProvider>
                <GradientProvider>
                  <EditWheelProvider>
                    <ColorProvider>
                      <GoogleOAuthProvider clientId={Client_App_ID.GOOGLE_ID}>
                        <div className="App">
                          <ToastContainer
                            position="top-right"
                            autoClose={2000}
                            hideProgressBar={true}
                            newestOnTop={true}
                            style={{ zIndex: 999999999 }}
                          />
                          <QueryClientProvider client={queryClient}>
                            <NotificationHandler />
                            <Routes />
                            <CreateFolderDialog />
                            <DialogPopup />
                            <UpgradePopup />
                          </QueryClientProvider>
                        </div>
                      </GoogleOAuthProvider>
                    </ColorProvider>
                  </EditWheelProvider>
                </GradientProvider>
              </WheelSegmentsProvider>
            </MyProvider>
          </DndProvider>
        </ThemeProvider>
      </Provider>
    </BrowserRouter>
  );
};

export default App;
